import { Sizes } from "frontend/data/shapes/sizes";
import { useEffect, useState } from "react";
import { Image } from "react-konva";

export function GhostNounIcon({ url }: { url: string }) {
  const [image, setImage] = useState<HTMLImageElement>();
  const size = Sizes.get().nounIcon.size;

  useEffect(() => {
    if (url) {
      const img = document.createElement("img");
      img.width = size;
      img.height = size;
      img.style.visibility = "hidden";
      img.addEventListener("load", () => setImage(img));
      img.src = url;
      document.body.append(img);
      return () => {
        document.body.removeChild(img);
      };
    }
  }, [url]);

  return <Image image={image} />;
}
